
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inspiration/[...inspiration-pages]",
      function () {
        return require("private-next-pages/inspiration/[...inspiration-pages].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inspiration/[...inspiration-pages]"])
      });
    }
  